export enum RestApiSenderAuthType {
	NoAuth = 1,
	BasicAuth = 2,
	APIKey = 3,
	BearerToken = 4,
	JWTBearer = 5,
	AWSSignature = 6,
}
